// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_RECENT_POSTS = "Nejnov\u011bj\u0161\u00ed ot\u00e1zky z poradny";
export const FORUM_RELATED_DISCUSSIONS = "Souvisej\u00edc\u00ed diskuze";
export const FORUM_SIMILAR_DISCUSSIONS = "Podobn\u00e9 diskuze";
export const RELATED_DISCUSSIONS_IN_FORUM = "Souvisej\u00edc\u00ed diskuze ve f\u00f3ru";
export const STROLLER_MORE_REVIEWS = "Dal\u0161\u00ed hodnocen\u00ed";
export const TO_REVIEW_CENTRE = "do Centra recenz\u00ed";
export const WIKI_EXPERIENCES_WITH_title = "Hodnocen\u00ed a zku\u0161enosti %(title)s";
export const WIKI_WRITE_YOUR_FIRST_EXPERIENCE = "Bu\u010f prvn\u00ed a napi\u0161 hodnocen\u00ed";
export const YOUTUBE_MK_TITLE = "YouTube Modr\u00fd kon\u00edk";
